import * as React from "react";
const SvgShopping = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14" {...props}>
    <path d="M18 5.75v.5a.75.75 0 0 1-.75.75H17l-.816 5.712A1.5 1.5 0 0 1 14.699 14H3.301a1.5 1.5 0 0 1-1.485-1.288L1 7H.75A.75.75 0 0 1 0 6.25v-.5A.75.75 0 0 1 .75 5h2.104L6.191.412A1 1 0 0 1 7.81 1.588L5.327 5h7.346L10.19 1.588A1 1 0 0 1 11.81.412L15.146 5h2.104a.75.75 0 0 1 .75.75Zm-8.25 5.5v-3.5a.75.75 0 1 0-1.5 0v3.5a.75.75 0 0 0 1.5 0Zm3.5 0v-3.5a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0Zm-7 0v-3.5a.75.75 0 1 0-1.5 0v3.5a.75.75 0 0 0 1.5 0Z" />
  </svg>
);
export default SvgShopping;
